import React from "react";
import FormModal from "../../../../components/Modal/FormModal";

const NotificationView = ({ isOpen, onClose, notification }) => {
  if (!isOpen || !notification) return null;

  return (
    <FormModal isOpen={isOpen} onClose={onClose} title="View Store">
      <div className="text-sm text-gray-800 space-y-6">
        <div className="grid grid-cols-[25%_75%] gap-y-4">
          <div className="text-xs font-bold text-gray-800">ID:</div>
          <div className="break-words">{notification.id}</div>

          <div className="text-xs font-bold text-gray-800">Title:</div>
          <div>{notification.title}</div>

          <div className="text-xs font-bold text-gray-800">Message:</div>
          <div className="break-words">{notification.message}</div>

          <div className="text-xs font-bold text-gray-800">Type:</div>
          <div className="break-words">
            <span className="px-2 py-0.5 bg-sky-100 text-xs">
              {notification.entityType}
            </span>
          </div>

          <div className="text-xs font-bold text-gray-800">Country:</div>
          <div className="break-words">
            {notification.country || (
              <span className="px-2 py-0.5 bg-orange-100 text-xs">Not set</span>
            )}
          </div>

          <div className="text-xs font-bold text-gray-800">Entity:</div>
          <div className="break-words">
            {notification.entityId && notification.entityId > 0 ? (
              notification.entityId
            ) : (
              <span className="px-2 py-0.5 bg-orange-100 text-xs">Not set</span>
            )}
          </div>

          <div className="text-xs font-bold text-gray-800">Link:</div>
          <div className="break-words">
            {notification.link || (
              <span className="px-2 py-0.5 bg-orange-100 text-xs">Not set</span>
            )}
          </div>

          <div className="text-xs font-bold text-gray-800">Expires At:</div>
          <div className="break-words">
            {new Date(notification.expiresAt).toLocaleString("uk-UA")}
          </div>
        </div>
      </div>
    </FormModal>
  );
};

export default NotificationView;
